package site.shadadman.pages.worklog.bit24cash

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initSept92025Bit24FirstSprintPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/bit24cash/sept92025Bit24FirstSprint.md", FrontMatterElement.EmptyMap))
}

@Page("/worklog/bit24cash/sept92025-bit24-first-sprint")
@Composable
fun Sept92025Bit24FirstSprintPage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("sept-9-2025-bit24-first-sprint") }) {
        org.jetbrains.compose.web.dom.Text("sept-9-2025-bit24-First-Sprint")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I alwayse loved the first sprint in all of my entire workline for two reason, first finaly you can starting with coding and second is meeting with my teammates.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Thay had this amazing crypto exchange platform called bit24. At the time I joined them they were already at top of thier fields.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The source code was quite large packed in feature based modules. One thing that was really intersting is that each feature module was only had the presentation layer, data & domain for each feature were located inside the ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("services")
        }
        org.jetbrains.compose.web.dom.Text(" module. Somthing like this:")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code { org.jetbrains.compose.web.dom.Text("""- user
    - presentation
- wallet
    - presentation
- ticket
    - presentation
- services
    - user
        - data
        - domain
    - wallet
        - data
        - domain
    - ticket
        - data
        - domain
""") } }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I found this arch very effective and a briliant idea. this not only seperates ui from buniess logic in code it also seperates it in module layer. This clean arch was compined with MVI. I loved MVI at my first impression on it when i worked at SportsGamex. I like its ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("contract")
        }
        org.jetbrains.compose.web.dom.Text(" logic and i think it maches well with composables, make the ui code cleaner.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("My cleages are very nice sepcialy Mohammad and Amir. Thier managment stack was, teams, gitlab and clickup. I remined myself that there was no ios applicaation at the time, Only Android.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I got hired mostly beacuse of my expirence in Kotlin Multiplatform. I believe they will migrate to kmp in near future.")
    }
}
